import { backendApi } from './requests';
import { API_LOCALE } from 'redux/language';

/**
 * Запити до CMS.
 *
 * Формат відповіді плаский: колекція — масив, запис — об'єкт. Обгорток
 * `data` / `attributes` тут немає, як і параметрів `populate`, `fields`,
 * `pagination` і `sort` у рядку запиту: зв'язки завжди приходять розгорнутими,
 * а порядок задає сервер (backend/src/sections.js).
 *
 * Єдине, що фронтенд таки передає, — мова: лише він знає, яку зараз обрано.
 * Записи, яких ще не переклали, CMS віддає українською.
 *
 * Кожна функція повертає пару `[error, data]` — контракт задає перехоплювач
 * у requests.js.
 */

const locale = (language) => `locale=${API_LOCALE[language] || API_LOCALE.ua}`;

export const getArticlesFetch = (language) => backendApi.get(`/articles?${locale(language)}`);
export const getArticleFetch = (articleId, language) =>
  backendApi.get(`/articles/${articleId}?${locale(language)}`);

export const getEventsFetch = (language) => backendApi.get(`/events?${locale(language)}`);

/**
 * Захід за ключем з адреси сайту: або зовнішній ідентифікатор змагання
 * (тоді знайдеться доповнення до нього), або слаг власного заходу.
 *
 * Обидва випадки веде один маршрут CMS — щоб фронтенд не будував `filters`
 * у рядку запиту й не знав, у якому полі що лежить.
 */
export const getEventLookupFetch = (key, language) =>
  backendApi.get(`/events/lookup/${encodeURIComponent(key)}?${locale(language)}`);

/**
 * Архів заходів: те, що вже минуло, сторінками від найсвіжішого.
 * Відповідь має вигляд { data, meta } — це єдиний розділ із пагінацією, бо
 * архів росте нескінченно, а решта розділів має відомий і невеликий розмір.
 */
export const getEventsArchiveFetch = (page = 1, limit = 24, language) =>
  backendApi.get(`/events/archive?page=${page}&limit=${limit}&${locale(language)}`);

export const getOrganizationsFetch = (language) => backendApi.get(`/organizations?${locale(language)}`);

export const getDocumentsFetch = (language) => backendApi.get(`/documents?${locale(language)}`);
export const getDocumentTypesFetch = (language) => backendApi.get(`/document-types?${locale(language)}`);

export const getManagementFetch = (language) => backendApi.get(`/management?${locale(language)}`);

export const getHistoryFetch = (language) => backendApi.get(`/history?${locale(language)}`);

export const getContactInfoFetch = (language) => backendApi.get(`/contact-info?${locale(language)}`);
